import api from './axiosConfig';

const PresupuestoService = {
  /**
   * Crea un nuevo presupuesto
   * @param {Object} presupuestoData - Datos del presupuesto
   * @returns {Promise<Object>} - Datos del presupuesto creado
   */
  crearPresupuesto: async (presupuestoData) => {
    try {
      const response = await api.post('/presupuesto', presupuestoData);
      if (response.status === 201) {
        console.log('✅ Presupuesto creado con éxito');
        console.log('Presupuesto:', response.data);
        return response.data;
      } else {
        throw new Error('No se pudo crear el presupuesto.');
      }
    } catch (error) {
      console.error('❌ Error al crear presupuesto:', error);
      throw error;
    }
  },

  /**
   * Obtiene todos los presupuestos de una empresa
   * @param {string} empresaId
   * @returns {Promise<Array>}
   */
  listarPresupuestos: async (empresaId) => {
    try {
      const response = await api.get(`/presupuesto/empresa/${empresaId}`);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error('Error al obtener presupuestos');
      }
    } catch (error) {
      console.error('❌ Error al listar presupuestos:', error);
      throw error;
    }
  },

  /** Presupuestos de un proyecto (los que no cuelgan de una obra). */
  listarDeProyecto: async (empresaId, proyectoId) => {
    const response = await api.get(`/presupuesto/empresa/${empresaId}`, { params: { proyecto_id: proyectoId, sin_ejecutado: 1 } });
    return response.data?.presupuestos || [];
  },

  listarPorProveedor: async (empresaId, proveedorNombre, { tipo } = {}) => {
    const params = new URLSearchParams({ proveedor: proveedorNombre });
    if (tipo) params.set('tipo', tipo);
    const response = await api.get(`/presupuesto/empresa/${empresaId}?${params.toString()}`);
    return response.data?.presupuestos || [];
  },

  /**
   * Modifica un presupuesto existente por código
   * @param {number} codigo - Código del presupuesto
   * @param {Object} data - Datos a modificar (incluye empresa_id y nuevo_monto)
   * @returns {Promise<void>}
   */
  modificarPresupuesto: async (codigo, data) => {
    try {
      const response = await api.put(`/presupuesto/${codigo}`, data);
      if (response.status === 200) {
        console.log('✅ Presupuesto actualizado con éxito');
      } else {
        throw new Error('Error al actualizar presupuesto');
      }
    } catch (error) {
      console.error('❌ Error al modificar presupuesto:', error);
      throw error;
    }
  },
    /**
   * Recalcula el ejecutado de un presupuesto por código
   * @param {number} codigo - Código del presupuesto
   * @param {string} empresaId - ID de la empresa
   * @returns {Promise<Object>} - Presupuesto actualizado
   */
    recalcularPresupuesto: async (id, empresaId) => {
      try {
        const response = await api.post(`/presupuesto/${id}/recalcular`, {
          empresa_id: empresaId,
        });
        if (response.status === 200) {
          console.log('✅ Presupuesto recalculado con éxito');
          return response.data;
        } else {
          throw new Error('Error al recalcular presupuesto');
        }
      } catch (error) {
        console.error('❌ Error al recalcular presupuesto:', error);
        throw error;
      }
    },
    
  /**
   * Elimina un presupuesto por código
   * @param {number} codigo - Código del presupuesto
   * @param {string} empresaId - ID de la empresa
   * @returns {Promise<void>}
   */
  eliminarPresupuesto: async (codigo, empresaId) => {
    try {
      const response = await api.delete(`/presupuesto/${codigo}`, {
        data: { empresa_id: empresaId },
      });
      if (response.status === 200) {
        console.log('✅ Presupuesto eliminado con éxito');
      } else {
        throw new Error('Error al eliminar presupuesto');
      }
    } catch (error) {
      console.error('❌ Error al eliminar presupuesto:', error);
      throw error;
    }
  },

  /**
   * Agregar adicional a un presupuesto
   * @param {string} presupuestoId - ID del presupuesto
   * @param {Object} adicionalData - Datos del adicional (concepto, monto)
   * @returns {Promise<Object>} - Presupuesto actualizado
   */
  agregarAdicional: async (presupuestoId, adicionalData) => {
    try {
      const response = await api.post(`/presupuesto/${presupuestoId}/adicional`, adicionalData);
      if (response.status === 200) {
        console.log('✅ Adicional agregado con éxito');
        return response.data;
      } else {
        throw new Error('Error al agregar adicional');
      }
    } catch (error) {
      console.error('❌ Error al agregar adicional:', error);
      throw error;
    }
  },

  /**
   * Editar un adicional existente
   * @param {string} presupuestoId - ID del presupuesto
   * @param {string} adicionalId - ID del adicional
   * @param {Object} data - { concepto, monto, fecha_adicional, creadoPor }
   * @returns {Promise<Object>}
   */
  editarAdicional: async (presupuestoId, adicionalId, data) => {
    try {
      const response = await api.put(`/presupuesto/${presupuestoId}/adicional/${adicionalId}`, data);
      if (response.status === 200) {
        console.log('✅ Adicional editado con éxito');
        return response.data;
      } else {
        throw new Error('Error al editar adicional');
      }
    } catch (error) {
      console.error('❌ Error al editar adicional:', error);
      throw error;
    }
  },

  /**
   * Eliminar un adicional de un presupuesto
   * @param {string} presupuestoId - ID del presupuesto
   * @param {string} adicionalId - ID del adicional
   * @returns {Promise<Object>}
   */
  eliminarAdicional: async (presupuestoId, adicionalId) => {
    try {
      const response = await api.delete(`/presupuesto/${presupuestoId}/adicional/${adicionalId}`);
      if (response.status === 200) {
        console.log('✅ Adicional eliminado con éxito');
        return response.data;
      } else {
        throw new Error('Error al eliminar adicional');
      }
    } catch (error) {
      console.error('❌ Error al eliminar adicional:', error);
      throw error;
    }
  },

  /**
   * Editar monto de un presupuesto (con historial)
   * @param {string} presupuestoId - ID del presupuesto
   * @param {Object} data - { nuevoMonto, motivo, creadoPor }
   * @returns {Promise<Object>}
   */
  /** Sin `aplicar` es la vista previa; devuelve una fila por presupuesto. */
  configuracionEnLote: async (cuerpo) => {
    const response = await api.post('/presupuesto/configuracion-lote', cuerpo);
    return response.data?.filas || [];
  },

  editarPresupuesto: async (presupuestoId, data) => {
    try {
      const response = await api.put(`/presupuesto/${presupuestoId}/editar`, data);
      if (response.status === 200) {
        console.log('✅ Presupuesto editado con éxito');
        return response.data;
      } else {
        throw new Error('Error al editar presupuesto');
      }
    } catch (error) {
      console.error('❌ Error al editar presupuesto:', error);
      throw error;
    }
  },

  /**
   * Obtener resumen de presupuestos por proyecto
   * @param {string} proyectoId - ID del proyecto
   * @param {string} empresaId - ID de la empresa
   * @returns {Promise<Object>} - Resumen con ingresos, egresos y totales
   */
  obtenerResumenProyecto: async (proyectoId, empresaId) => {
    try {
      const response = await api.get(`/presupuesto/proyecto/${proyectoId}/resumen?empresa_id=${empresaId}`);
      if (response.status === 200) {
        console.log('✅ Resumen de proyecto obtenido');
        return response.data;
      } else {
        throw new Error('Error al obtener resumen de proyecto');
      }
    } catch (error) {
      console.error('❌ Error al obtener resumen de proyecto:', error);
      throw error;
    }
  },

  /**
   * Obtener el resultado real de un proyecto: los movimientos que ejecutan presupuestos
   * de la obra, ya valuados en ARS y en USD histórico por el backend (SDS-33).
   * @param {string} proyectoId
   * @param {string} empresaId
   * @param {Object} [opciones]
   * @param {number|null} [opciones.anio] - año a analizar; null = todo el historial
   * @param {number|null} [opciones.tipoCambioActual] - el TC que muestra la pantalla
   * @returns {Promise<Object>} - { movimientos, totales, evolucion, aniosDisponibles, tipoCambioActual }
   */
  /**
   * Totales del resultado real de varias obras en una llamada (TAR-1295): tarjetas de la
   * vista general. Devuelve { [proyectoId]: { totales: { ars, usdHistorico } } }.
   */
  obtenerResultadoRealProyectos: async (proyectoIds, empresaId, { tipoCambioActual = null } = {}) => {
    try {
      const params = new URLSearchParams({ empresa_id: empresaId, proyecto_ids: proyectoIds.join(',') });
      if (tipoCambioActual) params.set('tipo_cambio_actual', String(tipoCambioActual));
      const response = await api.get(`/presupuesto/resultado-real?${params.toString()}`);
      if (response.status === 200 && response.data?.success) {
        return response.data.resultados;
      }
      throw new Error(response.data?.error || 'Error al obtener el resultado real');
    } catch (error) {
      console.error('❌ Error al obtener el resultado real de los proyectos:', error);
      throw error;
    }
  },

  obtenerResultadoRealProyecto: async (proyectoId, empresaId, { anio = null, tipoCambioActual = null } = {}) => {
    try {
      const params = new URLSearchParams({ empresa_id: empresaId });
      if (anio) params.set('anio', String(anio));
      if (tipoCambioActual) params.set('tipo_cambio_actual', String(tipoCambioActual));
      const response = await api.get(`/presupuesto/proyecto/${proyectoId}/resultado-real?${params.toString()}`);
      if (response.status === 200 && response.data?.success) {
        return response.data.resultado;
      }
      throw new Error(response.data?.error || 'Error al obtener el resultado real');
    } catch (error) {
      console.error('❌ Error al obtener el resultado real del proyecto:', error);
      throw error;
    }
  },

  /**
   * Movimientos que ejecutan cada presupuesto de la obra, ya valuados por el backend en
   * la unidad de su presupuesto con el mismo cálculo que el ejecutado (SDS-33).
   * @param {string} proyectoId
   * @param {string} empresaId
   * @returns {Promise<Array>} - [{ presupuesto_id, tipo, moneda, cac_tipo, base_calculo,
   *                                es_general, fecha_inicio, ejecutado, movimientos }]
   */
  obtenerMovimientosPorPresupuesto: async (proyectoId, empresaId) => {
    try {
      const params = new URLSearchParams({ empresa_id: empresaId });
      const response = await api.get(
        `/presupuesto/proyecto/${proyectoId}/movimientos-por-presupuesto?${params.toString()}`
      );
      if (response.status === 200 && response.data?.success) {
        return response.data.presupuestos || [];
      }
      throw new Error(response.data?.error || 'Error al obtener los movimientos por presupuesto');
    } catch (error) {
      console.error('❌ Error al obtener los movimientos por presupuesto:', error);
      throw error;
    }
  },

  /**
   * Obtener todos los movimientos de un proyecto (para desglose de presupuestos)
   * @param {string} proyectoId - ID del proyecto
   * @param {string} [tipo] - 'ingreso' | 'egreso' | null (todos)
   * @returns {Promise<Array>} - Lista de movimientos
   */
  obtenerMovimientosProyecto: async (proyectoId, tipo = null) => {
    try {
      const params = tipo ? `?tipo=${tipo}` : '';
      const response = await api.get(`/presupuesto/proyecto/${proyectoId}/movimientos${params}`);
      if (response.status === 200) {
        return response.data.movimientos || [];
      }
      throw new Error('Error al obtener movimientos');
    } catch (error) {
      console.error('❌ Error al obtener movimientos de proyecto:', error);
      throw error;
    }
  },

  /**
   * Eliminar presupuesto por ID de documento
   * @param {string} presupuestoId - ID del presupuesto
   * @returns {Promise<Object>}
   */
  eliminarPresupuestoPorId: async (presupuestoId) => {
    try {
      const response = await api.delete(`/presupuesto/doc/${presupuestoId}`);
      if (response.status === 200) {
        console.log('✅ Presupuesto eliminado con éxito');
        return response.data;
      } else {
        throw new Error('Error al eliminar presupuesto');
      }
    } catch (error) {
      console.error('❌ Error al eliminar presupuesto:', error);
      throw error;
    }
  },

  actualizarAdjuntos: async (presupuestoId, payload) => {
    try {
      const response = await api.put(`/presupuesto/${presupuestoId}/adjuntos`, payload);
      if (response.status === 200 && response.data?.success) {
        return response.data;
      }
      throw new Error(response.data?.error || 'Error al actualizar adjuntos');
    } catch (error) {
      console.error('❌ Error al actualizar adjuntos:', error);
      throw error;
    }
  },

  /** Partición de un pago o cobro en base + ajuste, sin persistir. */
  previsualizarPago: async (presupuestoId, datos) => {
    const response = await api.post(`/presupuesto/${presupuestoId}/partir-pago/preview`, datos);
    return response.data;
  },

  /** Registra el pago o cobro: un movimiento, o base + ajuste vinculado. */
  registrarPago: async (presupuestoId, datos) => {
    const response = await api.post(`/presupuesto/${presupuestoId}/pagos`, datos);
    return response.data;
  },

  /**
   * Un presupuesto con el armado de los items del resumen (monto nativo y ejecutado).
   * @param {string} presupuestoId
   * @returns {Promise<Object>}
   */
  obtenerPorId: async (presupuestoId) => {
    const response = await api.get(`/presupuesto/${presupuestoId}`);
    return response.data?.presupuesto;
  },

  /**
   * Componentes del presupuesto (original + adicionales) con su fecha base, y el desglose
   * original / adicionales / ajustes / total. Todo derivado en el backend.
   * @param {string} presupuestoId
   * @returns {Promise<{componentes: Array, desglose: Object, moneda: string}>}
   */
  obtenerComponentes: async (presupuestoId) => {
    try {
      const response = await api.get(`/presupuesto/${presupuestoId}/componentes`);
      return response.data;
    } catch (error) {
      console.error('❌ Error al obtener componentes del presupuesto:', error);
      throw error;
    }
  },

  /**
   * Preview de una actualización por índice (TAR-851). No persiste nada: devuelve el porcentaje
   * sugerido y el importe por componente, más los totales.
   * @param {string} presupuestoId
   * @param {{ indice: 'CAC'|'IPC', subindice: string|null, fecha: string }} params
   */
  previewAjuste: async (presupuestoId, params) => {
    const response = await api.post(`/presupuesto/${presupuestoId}/ajuste/preview`, params);
    return response.data;
  },

  /**
   * Aplica la actualización por índice. Solo se manda el porcentaje por componente: los importes
   * los recalcula el backend.
   * @param {string} presupuestoId
   * @param {{ indice: 'CAC'|'IPC', subindice: string|null, fecha: string, componentes: Array, creadoPor: string }} payload
   */
  aplicarAjuste: async (presupuestoId, payload) => {
    const response = await api.post(`/presupuesto/${presupuestoId}/ajuste`, payload);
    return response.data;
  },

  /**
   * Deshace un ajuste por índice. El backend solo acepta el último y rechaza cualquier otro.
   * @param {string} presupuestoId
   * @param {string} ajusteId
   */
  eliminarAjuste: async (presupuestoId, ajusteId) => {
    const response = await api.delete(`/presupuesto/${presupuestoId}/ajuste/${ajusteId}`);
    return response.data;
  },

  /**
   * Descarga un Excel con todos los movimientos del presupuesto y sus equivalencias.
   * @param {string} presupuestoId - ID del presupuesto
   * @param {string} nombreArchivo - Nombre sugerido del archivo (sin extensión)
   */
  exportarMovimientos: async (presupuestoId, nombreArchivo = 'movimientos-presupuesto') => {
    const response = await api.get(`/presupuesto/${presupuestoId}/export-movimientos`, {
      responseType: 'blob',
    });
    const url = URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nombreArchivo}.xlsx`;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export default PresupuestoService;


